import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BatteryWarningIcon, WindIcon, FrownIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-4 bg-terracotta/5 relative" data-id="element-94">
      <div className="max-w-4xl mx-auto" data-id="element-95">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-96">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-97">
            ¿Te suena familiar?
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-98">
            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-terracotta/10 flex flex-col items-center text-center" data-id="element-99">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-4 text-terracotta" data-id="element-100">
                <BatteryWarningIcon className="w-6 h-6" data-id="element-101" />
              </div>
              <p className="text-brown/80" data-id="element-102">
                Sentís pesadez después de cada comida y te sentís cansada aunque
                duermas.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-terracotta/10 flex flex-col items-center text-center" data-id="element-103">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-4 text-terracotta" data-id="element-104">
                <WindIcon className="w-6 h-6" data-id="element-105" />
              </div>
              <p className="text-brown/80" data-id="element-106">
                Tenés gases que te incomodan en el trabajo y no te dejan
                concentrarte.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-white p-6 rounded-2xl shadow-sm border border-terracotta/10 flex flex-col items-center text-center" data-id="element-107">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-4 text-terracotta" data-id="element-108">
                <FrownIcon className="w-6 h-6" data-id="element-109" />
              </div>
              <p className="text-brown/80" data-id="element-110">
                Perdiste la confianza de ponerte la ropa que te gusta por miedo
                a cómo te va a quedar a mitad del día.
              </p>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="bg-terracotta/10 p-8 rounded-3xl text-center max-w-3xl mx-auto" data-id="element-111">
            <p className="text-xl text-brown font-medium leading-relaxed" data-id="element-112">
              Probaste dejar las harinas y terminaste con más ansiedad.
              Compraste el yogur "light" del súper y te infló el doble. Leíste
              consejos de afuera que te piden ingredientes que en Argentina no
              se consiguen o cuestan una locura.
            </p>
            <p className="mt-4 text-lg text-terracotta font-bold" data-id="element-113">
              El problema no sos vos, es que estás aplicando soluciones que no
              están adaptadas a tu realidad.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}